module.exports = __webpack_public_path__ + "img/events.84fbd6df.svg";